import { render } from "./TodoList.vue?vue&type=template&id=53fc676d&scoped=true"
import script from "./TodoList.vue?vue&type=script&lang=js"
export * from "./TodoList.vue?vue&type=script&lang=js"

import "./TodoList.vue?vue&type=style&index=0&id=53fc676d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53fc676d"]])

export default __exports__